import { createZodDto } from 'nestjs-zod/dto';
import { AcceptOrganizationInvitationSchema } from './accept-organization-invitation.dto';
export const AcceptSsoInvitationForNewMemberSchema = AcceptOrganizationInvitationSchema;
export class AcceptSsoInvitationForNewMemberDto extends createZodDto(AcceptSsoInvitationForNewMemberSchema) {
}
